<app-menu-bar></app-menu-bar>
<router-outlet  [hidden]="!globals.hasLoaded"  style="height:100%">        
</router-outlet>
<div *ngIf="!globals.hasLoaded" class="k-i-loading"></div>
<div class="ad2hs-prompt bounceInUp" (click)="addToHomescreen()" *ngIf="installBtn">
        <h1>Add {{title}} To Your Homescreen!</h1>
        <div class="btn btn-premium">Add</div>
</div>